import { render } from "./AIAssistant.vue?vue&type=template&id=b893255a&scoped=true"
import script from "./AIAssistant.vue?vue&type=script&lang=js"
export * from "./AIAssistant.vue?vue&type=script&lang=js"

import "./AIAssistant.vue?vue&type=style&index=0&id=b893255a&scoped=true&lang=css"
import "./AIAssistant.vue?vue&type=style&index=1&id=b893255a&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b893255a"]])

export default __exports__